import React from 'react'
import { parseJwt, history } from '@helpers'
import Title from '../../components/typography/title.component'
import Button from '../../components/buttons/buttons.component'
import Container from '../../components/layout/container.component'
import AddressForm from './components/address-form.component'
import PasswordForm from './components/password-form.component'
import NewsletterForm from './components/newsletter-form.component'
import PersonalForm from './components/personal-form.component'
import ComplementaryForm from './components/complementary-form.component'
import AccordionSecondary from '../../components/accordion/accordion-secondary.component'
import { routes } from '../../constants/routes.constants'
import { facebookApp, googleApp } from '../../constants/social-login.constants'
import { connect } from 'react-redux'
import { UserService } from '../../services/user.service'
import { toastActions, userActions } from '../../actions'
import { RoleConstants } from '../../constants'
import { registerClient } from './services/register-client.service'
import { Link, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { FriendInviteService } from './../../services/friend-invite.service'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { Creators as AuthenticationCreators } from '../../ducks/authentication/authentication'
import {
	StyledRegister,
	StyledStepFrom,
	StyleSocialLogin,
	StyledPage
} from './register.page.styles.js'

import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import faceLogo from '../../../../client/assets/icons/facebook-logo.svg'
import { AuthenticationService, StorageService } from '../../services'

// TODO: Refatorar componente Accordion dentro de AccordionSecondary para não precisar passar positions.
const STEP = Object.freeze({
	PERSONAL_FORM: { positon: 0, name: 'personalForm' },
	COMPLEMENTARY_FORM: { positon: 1, name: 'complementaryForm' },
	// ADDRESS_FORM: { positon: 2, name: 'addressForm' },
	PASSWORD_FORM: { positon: 2, name: 'passwordForm' },
	NEWSLETTER_FORM: { positon: 3, name: 'newsletterForm' }
})

class RegisterPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			username: '',
			success: null,
			registerWithEmail: false,
			currentStep: STEP.PERSONAL_FORM,
			data: {},
			validForms: []
		}

		this.validateForm = this.validateForm.bind(this)
		this.validateToSend = this.validateToSend.bind(this)

		FriendInviteService.setInviteHash()
	}

	async componentDidMount() {
		await this.redirectToIntialPageIfLogged()
	}

	async redirectToIntialPageIfLogged() {
		const { history, user } = this.props

		if (user) {
			const role = await UserService.getMostImportantRole(user.roles)
			switch (role) {
				case RoleConstants.Client:
					history.replace(`${routes.CLIENTE}/loja-muviflex`)
					break

				case RoleConstants.Admin:
					history.replace(`${routes.ADMIN}`)
					break

				case RoleConstants.Partner:
					history.replace(`${routes.PARCEIRO}`)
					break

				default:
					break
			}
		}
	}

	onChangeStep() {
		try {
			this.refs[this.state.currentStep.name].onEnter()
			this.refs[this.state.currentStep.name].refs.form.submitForm()
		} catch (error) {}
	}

	goToStep = nextStep => {
		this.setState({ currentStep: nextStep }, () => {
			this.refs.steps.openJustTheItem(this.state.currentStep.positon)
			this.onChangeStep()
		})
	}

	checkStep = message => isValid => {
		const { toastError } = this.props

		if (!isValid) {
			toastError({
				message
			})
		}

		this.validFormsControl(isValid)

		return isValid
	}

	validateForm = (schema, values) => {
		return schema
			.validate(values, { abortEarly: false })
			.then(() => {
				if (this.validFormsControl) {
					this.validFormsControl(true)
				}

				return {}
			})
			.catch(err => {
				const errors = {}

				if (err.inner && err.inner.length) {
					err.inner.forEach(e => {
						if (e.path) errors[e.path] = e.message
					})
				} else if (err.path) {
					errors[err.path] = err.message
				}

				if (this.validFormsControl) {
					this.validFormsControl(false)
				}

				return errors
			})
	}

	validFormsControl = isValid => {
		const stepName = this.state.currentStep.name

		this.setState(prevState => {
			const currentValidForms = prevState.validForms
			const isIncluded = currentValidForms.includes(stepName)

			if (isValid && !isIncluded) {
				return { validForms: [...currentValidForms, stepName] }
			}

			if (!isValid && isIncluded) {
				return {
					validForms: currentValidForms.filter(name => name !== stepName)
				}
			}
		})
	}

	setRegisterWithEmail = () => {
		this.setState({ registerWithEmail: true })
	}

	handleResponseError = data => {
		const { hideLoading, toastError, toastCloseCurrent } = this.props

		if (data && data.errors && data.errors[0]) {
			toastError({
				message:
					data.errors[0] ===
					'Atenção: Identificamos que você já possui cadastro. Por favor, utilize a opção “Esqueceu sua senha?” e, em seguida, consulte seu e-mail para redefinir sua senha.'
						? () => (
								<span>
									Já existe um usuário cadastrado com os dados
									informados.
									<br />
									<Link
										style={{ color: 'white ' }}
										to={routes.ENTRAR}
										onClick={toastCloseCurrent}>
										Clique aqui
									</Link>{' '}
									para entrar
								</span>
						  )
						: data.errors[0]
			})
		} else {
			toastError({
				message:
					'Não foi possível efetuar o cadastro, por favor tente novamente mais tarde'
			})
		}

		hideLoading()
	}

	setDataToSend() {
		const {
			personalForm,
			complementaryForm,
			addressForm,
			passwordForm
		} = this.refs

		const personalData = personalForm.refs.form.state.values
		const {
			phone,
			gender,
			birthday,
			rideApp
		} = complementaryForm.refs.form.state.values
		const passwordData = passwordForm.passwordRef.current.value
		// const addressData = addressForm.refs.form.state.values

		return {
			...personalData,
			name: personalData.name.trim(),
			email: personalData.email.trim().toLowerCase(),
			phone,
			gender,
			birthday,
			rideApp,
			password: passwordData,
			newsletter: this.props.newsletter,
			inviteHash: FriendInviteService.getInviteHash()
		}
	}

	checkValidForms = () => {
		const { validForms, currentStep } = this.state
		const stepList = Object.values(STEP)
		const otherSteps = stepList
			.map(step => step.name)
			.filter(name => name !== currentStep.name)

		return otherSteps.every(name => {
			if (!validForms.includes(name)) {
				this.goToStep(stepList.find(step => step.name === name))
				return false
			}

			return true
		})
	}

	validateToSend() {
		if (!this.checkValidForms()) {
			this.props.toastError({
				message:
					'Preencha os campos obrigatórios antes de finalizar o cadastro.'
			})

			return
		}

		this.sendForm()
	}

	sendForm = async () => {
		const { showLoading, hideLoading } = this.props

		const data = this.setDataToSend()

		showLoading()

		registerClient(data)
			.then(result => {
				if (result.success) {
					this.setState({ success: true, data: data }, () => {
						hideLoading()
						FriendInviteService.eraseInviteHash()
						setTimeout(window.scrollTo(0, 0), 0)
					})
				} else {
					this.handleResponseError(result)
				}
			})
			.catch(({ response }) => {
				this.handleResponseError(response && response.data)
			})
	}

	renderSuccess = () => {
		return (
			<StyledPage>
				<Container>
					<div>
						<Title>
							Quase lá
							<span className="bold">!</span>
						</Title>
						<p>
							Um e-mail de confirmação foi enviado para{' '}
							{this.state.data.email}
							.
							<br />
							Verifique sua caixa de emails (inclusive caixa de spams)
							para confirmar o cadastro no programa Muviflex
						</p>
					</div>
				</Container>
			</StyledPage>
		)
	}

	handleSocialLoginResponse = res => {
		const { setProviderSignupData, userLogin, hideLoading } = this.props

		if (res.success) {
			if (res.data.shouldRedirectToSignUp) {
				setProviderSignupData(res.data)
				history.push(routes.LOGIN_SOCIAL_CADASTRO)
			} else if (!!res.data.accessToken) {
				let user = res.data

				userLogin(user)

				hideLoading()

				history.push('/')
			}
		}
	}

	onFacebookResponse = providerResponse => {
		const { hideLoading, showLoading, toastError } = this.props
		const message =
			'Não foi possível autenticar com o Facebook, tente novamente mais tarde.'

		if (providerResponse.status === 'unknown') return

		if (providerResponse.status && providerResponse.status !== 'unknown') {
			toastError({ message })
			return
		}

		showLoading()
		AuthenticationService.socialLogin('facebook', {
			AccessToken: providerResponse.accessToken
		})
			.then(result => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				toastError({ message })
				hideLoading()
			})
	}

	onGoogleResponse = providerResponse => {
		const { hideLoading, showLoading, toastError } = this.props
		const message =
			'Não foi possível autenticar com o Google, tente novamente mais tarde.'

		showLoading()

		showLoading()
		AuthenticationService.socialLogin('google', {
			TokenId: providerResponse.tokenId
		})
			.then(result => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				toastError({ message })
				hideLoading()
			})
	}

	onGoogleFail = errors => {
		console.warn(errors)
	}

	renderLoginButtons = () => (
		<Container small>
			<Title>
				Cadastre-se e viaje <br /> muito mais com o <br />{' '}
				<span className="bold">Muviflex</span>
			</Title>
			<StyleSocialLogin>
				<div className="social-login-container">
					<GoogleLogin
						clientId={googleApp.clientId}
						buttonText="Entrar com o Google"
						onSuccess={this.onGoogleResponse}
						className="custom-google-button"
						onFailure={this.onGoogleFail}
						cookiePolicy={'single_host_origin'}
					/>
					{/* <FacebookLogin
						appId={facebookApp.appId}
						fields="id,name,email"
						icon={<img src={faceLogo} alt="" />}
						cssClass="custom-facebook-button"
						callback={this.onFacebookResponse}
						textButton="Entrar com o Facebook"
					/> */}

					<Button
						primary
						className={`button button-modal`}
						type="button"
						onClick={this.setRegisterWithEmail}>
						CADASTRE-SE COM O E-MAIL
					</Button>
				</div>
			</StyleSocialLogin>
		</Container>
	)

	renderFormRegister = () => (
		<Container small>
			<Title>
				Cadastre-se e viaje <br /> muito mais com o <br />{' '}
				<span className="bold">Muviflex</span>
			</Title>
			<StyledRegister>
				<AccordionSecondary
					ref={'steps'}
					arrow={true}
					multiple={false}
					{...this.props}
					items={[
						{
							title: 'Dados Pessoais',
							onClick: () =>
								this.setState({ currentStep: STEP.PERSONAL_FORM }),
							content: (
								<StyledStepFrom>
									<PersonalForm
										ref={STEP.PERSONAL_FORM.name}
										onSubmit={() =>
											this.goToStep(STEP.COMPLEMENTARY_FORM)
										}
										onClick={this.checkStep(
											'Informe corretamente seus dados pessoais para prosseguir'
										)}
										validateForm={this.validateForm}
									/>
								</StyledStepFrom>
							)
						},
						{
							title: 'Dados complementares',
							onClick: () =>
								this.setState({ currentStep: STEP.COMPLEMENTARY_FORM }),
							content: (
								<StyledStepFrom>
									<ComplementaryForm
										ref={STEP.COMPLEMENTARY_FORM.name}
										{...this.props}
										onSubmit={() => this.goToStep(STEP.PASSWORD_FORM)}
										onClick={this.checkStep(
											'Informe corretamente seus dados complementares para prosseguir'
										)}
										validateForm={this.validateForm}
										onBack={() => this.goToStep(STEP.PERSONAL_FORM)}
									/>
								</StyledStepFrom>
							)
						},
						// {
						// 	title: 'Endereço',
						// 	onClick: () =>
						// 		this.setState({ currentStep: STEP.ADDRESS_FORM }),
						// 	content: (
						// 		<StyledStepFrom>
						// 			<AddressForm
						// 				ref={STEP.ADDRESS_FORM.name}
						// 				onSubmit={() => this.goToStep(STEP.PASSWORD_FORM)}
						// 				onClick={this.checkStep(
						// 					'Informe corretamente seu endereço para prosseguir'
						// 				)}
						// 				onBack={() =>
						// 					this.goToStep(STEP.COMPLEMENTARY_FORM)
						// 				}
						// 				validateForm={this.validateForm}
						// 				{...this.props}
						// 			/>
						// 		</StyledStepFrom>
						// 	)
						// },
						{
							title: 'Senha',
							onClick: () =>
								this.setState({ currentStep: STEP.PASSWORD_FORM }),
							content: (
								<StyledStepFrom>
									<PasswordForm
										ref={STEP.PASSWORD_FORM.name}
										onSubmit={() =>
											this.goToStep(STEP.NEWSLETTER_FORM)
										}
										onClick={this.checkStep(
											'Senha informada não atende aos critérios de segurança'
										)}
										onBack={() =>
											this.goToStep(STEP.COMPLEMENTARY_FORM)
										}
										validateForm={this.validateForm}
									/>
								</StyledStepFrom>
							)
						},
						{
							title: 'Termos e condições de uso',
							onClick: () =>
								this.setState({ currentStep: STEP.NEWSLETTER_FORM }),
							content: (
								<StyledStepFrom>
									<NewsletterForm
										ref={STEP.NEWSLETTER_FORM.name}
										onSubmit={this.validateToSend}
										onBack={() => this.goToStep(STEP.PASSWORD_FORM)}
									/>
								</StyledStepFrom>
							)
						}
					]}
				/>
			</StyledRegister>
		</Container>
	)

	render() {
		const { success, registerWithEmail } = this.state
		if (success) return this.renderSuccess()

		if (!registerWithEmail) return this.renderLoginButtons()

		if (!success && registerWithEmail) return this.renderFormRegister()
	}
}

const mapStateToProps = ({ toast, user, newsletterOption }) => ({
	toast,
	user,
	newsletter: newsletterOption.newsletter
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			toastError: toastActions.danger,
			toastCloseCurrent: toastActions.closeCurrent,
			userLogin: userActions.login,
			setProviderSignupData: AuthenticationCreators.setProviderSignupData,
			setAccessToken: userActions.setAccessToken
		},
		dispatch
	)

const connectedRegisterPageComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RegisterPageComponent)
)

export { connectedRegisterPageComponent as ModuleRootComponent }
